import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  readonly currentLanguage = signal(this.findLanguage());

  findLanguage(): string {
    switch (navigator.language) {
      case 'fr':
        return 'fr';
      default:
        return 'nl';
    }
  }

  changeLanguage(newLanguage: string) {
    this.currentLanguage.set(newLanguage);
    localStorage.setItem('activeLanguage', newLanguage);
  }
}
